/**
 * Calculates days until birthday
 * @param {string} dateStr - Date string (DD/MM/YYYY or ISO format)
 * @returns {number|null} Days until birthday or null if invalid
 */
export function daysUntilBirthday(dateStr) {
  if (!dateStr) return null;

  const today = new Date();
  const todayMidnight = new Date(today.getFullYear(), today.getMonth(), today.getDate());

  let bday;
  if (dateStr.includes("/")) {
    const parts = dateStr.split("/");
    bday = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
  } else {
    bday = new Date(dateStr);
  }

  if (isNaN(bday)) return null;

  const thisYear = new Date(todayMidnight.getFullYear(), bday.getMonth(), bday.getDate());
  if (thisYear < todayMidnight) thisYear.setFullYear(todayMidnight.getFullYear() + 1);

  return Math.round((thisYear - todayMidnight) / (1000 * 60 * 60 * 24));
}

/**
 * Formats date string
 * @param {string} dateStr - Date string to format
 * @returns {string} Formatted date
 */
export function formatDate(dateStr) {
  if (!dateStr) return "";
  
  let d;
  if (dateStr.includes("/")) {
    const parts = dateStr.split("/");
    d = new Date(parseInt(parts[2]), parseInt(parts[1]) - 1, parseInt(parts[0]));
  } else {
    d = new Date(dateStr + "T00:00:00");
  }
  
  if (isNaN(d)) return dateStr;
  
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const date = String(d.getDate()).padStart(2, "0");
  
  return `${date}/${month}/${year}`;
}
